import store from "@/store";

class AdministratorAPI {
	API_GetAllCategoryGroup() {
		return `/api/_all/category-groups`;
	}

	API_GetAllCategoryGroupWithNoCustom() {
		return `/api/_all/category-groups-find-all-normal-with-no-custom`;
	}

	API_GetAllChildCategory(id, page = 0, size = 10) {
		return `api/_all-child/${id}/category-groups-pageable?page=${page}&size=${size}`;
	}

	API_GetAllCategoryGroupHasChild() {
		return `/api/_all_has_child/category-groups`;
	}

	API_CreateCategoryGroup() {
		return `/api/category-groups`;
	}

	API_UpdateCategoryGroup(id) {
		return `/api/category-groups/${id}`;
	}

	API_GetCategoryGroup(id) {
		return `/api/category-groups/${id}`;
	}

	// Đồng bộ TẤT CẢ người dùng vào danh mục người dùng (Admin hệ thống) — chạy nền.
	API_ResyncAllUsers() {
		return `/api/category-groups/resync-all-users`;
	}

	API_GetResyncAllUsersStatus() {
		return `/api/category-groups/resync-all-users/status`;
	}

	API_DeleteAttachmentFileSoftly(id) {
		return `/api/attachment-files/delete/${id}`;
	}

	API_DeleteAttachmentFileFromRequestDataIdSoftly(id) {
		return `/api/attachment-files/delete-file-anh-chu-ky-from-request-data-id/${id}`;
	}

	// API_DeleteCategoryGroup(id) {
	// 	return `/api/category-groups/${id}`;
	// }
	API_SaveAllCategoryGroup() {
		return `/api/_save/category-groups`;
	}

	API_GetAllChildByParentId(id) {
		return `/api/_all-child/${id}/category-groups`;
	}
	API_GetAllChildByParentIdV3(id, requestID) {
		return `/api/_all-child-v3/${id}/category-groups?requestDataId=${requestID}`;
	}

	API_GetAllChildByParentIdAndKeyWord(id, name, page = 0, size = 100) {
		if (!name || name === "undefined" || name === "null") name = "";
		if (name) name = encodeURIComponent(name);
		return `/api/_all-child/${id}/search_name/category-groups?name=${name}&page=${page}&size=${size}`;
	}

	API_GetAllChildByParentIdAndKeyWordV2(
		id,
		name,
		requestDataId,
		page = 0,
		size = 100,
	) {
		if (!name || name === "undefined" || name === "null") name = "";
		if (
			!requestDataId ||
			requestDataId === "undefined" ||
			requestDataId === "null"
		)
			name = "";
		if (name) name = encodeURIComponent(name);
		return `/api/_all-child/${id}/search_name/category-groups-v2?name=${name}&requestDataId=${requestDataId}&page=${page}&size=${size}`;
	}

	// Dành rieng form dong VJSF combobox/selector
	API_VJSF_GetCategoryDataV2(id, name, requestDataId) {
		// if (!name || name === "undefined" || name === "null") name = "";
		// if (
		// 	!requestDataId ||
		// 	requestDataId === "undefined" ||
		// 	requestDataId === "null"
		// )
		// 	name = "";
		// if (name) name = encodeURIComponent(name);

		// {q} là keyword để combobox vjsf tự động fill query input của user vào API Endpoint
		// không cần sử dụng params keyword truyền thủ công vào nữa
		// event trigger từ {q} chạy mượt và có debounce sẵn
		return `/api/_all-child/${id}/search_name/category-groups-v2?name={q}&requestDataId=${requestDataId}&page=0&size=1000`;
	}

	API_GetAllCategoryDataByCategoryGroupId(id) {
		return `/api/category-groups/${id}/_all/category-data`;
	}

	API_CreateCategoryData() {
		return `/api/category-data`;
	}

	API_UpdateCategoryData(id) {
		return `/api/category-data/${id}`;
	}

	API_SaveAllCategoryData() {
		return `/api/_save/category-data`;
	}

	// API_DeleteCategoryData(id) {
	// 	return `/api/category-data/${id}`;
	// }
	API_DeleteAllCategoryData() {
		return `/api/_delete/category-data`;
	}

	API_FindAllOrganization() {
		return `/api/_all/organizations`;
	}
	API_ViewReportRequestGroup() {
		return `/api/reportSystem/viewReportRequestGroup`;
	}
	API_ViewReportRequestType() {
		return `/api/reportSystem/viewReportRequestType`;
	}
	API_ViewReportUser() {
		return `/api/reportSystem/viewReportUser`;
	}
	API_FindAllOrganizationRole() {
		return `/api/workflow/_all/organizations/V2`;
	}

	API_FindCustomAllOrganization() {
		return `/api/_custom_all/organizations`;
	}

	API_GetllOrganizationWorkflow() {
		return `/api/workflow/_all/organizations`;
	}

	API_SaveAllOrganization() {
		return `/api/_save/organizations`;
	}

	API_CreateOrganization() {
		return `/api/organizations`;
	}

	API_DeleteOrganization(id) {
		return `/api/organizations/${id}`;
	}

	API_UpdateOrganization(id) {
		return `/api/organizations/${id}`;
	}

	API_SaveProcessInfo() {
		return `/api/process-infos`;
	}

	API_GetProcessInfo(id) {
		return `/api/process-infos/${id}`;
	}

	API_UpdateProcessInfo(id) {
		return `/api/process-infos/${id}`;
	}

	API_SaveAllRequest() {
		return `/api/_save/requests`;
	}

	API_GetAllProcessInfo() {
		return `/api/_all/process-infos`;
	}

	API_GetAllProcessInfoIgnoreFile() {
		return `/api/_all/process-infos?ignoreField=true`;
	}

	// API_GetPageProcessInfoIgnoreFile(
	// 	ignoreField = true,
	// 	page = 0,
	// 	pageSize = 10,
	// ) {
	// 	return `/api/_page/process-infos?ignoreField=${ignoreField}&page=${page}&size=${pageSize}`;
	// }
	API_GetAllRequestGroup() {
		return `/api/_all/request-groups`;
	}

	API_GetAllRequestGroupV2() {
		return `/api/_all/request-groups/V2`;
	}

	API_GetAllRequestType() {
		return `/api/_all/request-types`;
	}

	API_GetAllRequest() {
		return `/api/_all/requests`;
	}

	API_GetAllRequestEntities() {
		return `/api/_all/requests-entities`;
	}

	API_GetAllRequestIgnoreFile() {
		return `/api/_all_ignorefile/requests`;
	}

	API_CreateRequest() {
		return `/api/requests`;
	}

	API_SaveRequest(id) {
		return `/api/requests/${id}`;
	}

	API_GetAllTemplateForm() {
		return `/api/_all/template-forms`;
	}

	API_GetAllTemplateFormIgnoreField(ignoreField) {
		return `/api/_all/template-forms/V2/?ignoreFile=${ignoreField}`;
	}

	API_GetRequest(id) {
		return `/api/requests/${id}`;
	}

	API_CreateRequestGroup() {
		return `/api/request-groups`;
	}

	API_CreateRequestType() {
		return `/api/request-types`;
	}

	API_CreateTemplateForm() {
		return `/api/template-forms`;
	}

	API_SaveTemplateForm(id) {
		return `/api/template-forms/${id}`;
	}

	// Route_EditCategoryGroup(id) {
	// 	return `/administrator/danh-muc/${id}`;
	// }
	// Route_ListCategoryGroup() {
	// 	return `/administrator/danh-muc`;
	// }
	// API_SaveRequestData(id) {
	// 	return `/api/request-data/${id}`;
	// }
	API_CreateRequestData() {
		return `/api/request-data/`;
	}

	API_CreatePYCFromOtherPYC() {
		return `/api/request-data-from-other-pyc`;
	}

	API_CreateCongLenhConTuCongLenhCha() {
		return `/api/request-data-tao-cong-lenh-con-tu-cong-lenh-cha`;
	}

	API_FindOneRequestByID(id) {
		return `/api/request-types/${id}/requests`;
	}

	API_CreateProcessData() {
		return `/api/process-data`;
	}

	API_CreateFormData() {
		return `/api/form-data`;
	}

	API_CreateStepData() {
		return `/api/step-data`;
	}

	API_FindStepInProcessesByID(id) {
		return `/api/process-infos/${id}/_all/step-in-processes`;
	}

	API_GetRequestDataByID(id) {
		return `/api/request-data/${id}`;
	}

	API_GetFormDataById(id, ignoreField = true) {
		return `/api/request-data/${id}/_all/form-data?ignoreField=${ignoreField}`;
	}

	API_UpdateFormData(id) {
		return `/api/form-data/${id}`;
	}

	API_UpdateFormDataCustom(id) {
		return `/api/update_data/form_data/${id}`;
	}

	API_UpdateFormDataCustomNoFillIn(id) {
		return `/api/update_data/form_data/${id}?fillIn=false`;
	}

	API_FindProcessesDataByID(id) {
		return `/api/request-data/${id}/_all/process-data`;
	}

	// API_FindStepDataByID(id) {
	// 	return `/api/request-data/${id}/_all/step-data`;
	// }
	API_FindFieldInForm(id, ignoreField = true) {
		return `/api/forms/${id}/_all/field-in-form?ignoreField=${ignoreField}`;
	}

	// API_CreateFieldData() {
	// 	return `/api/field-data`;
	// }
	// API_GetFieldDataByIdRequest(id) {
	// 	return `/api/request-data/${id}/_all/field-data`;
	// }
	API_GetStepDataByIdRequest(id) {
		return `/api/request-data/${id}/_all/step-data`;
	}

	// API_GetStepDataByIdStepInProcessId(id) {
	// 	return `/api/step-in-processes/${id}/_all/user-in-steps`;
	// }
	API_GetAllRequestData() {
		return `/api/_all/request-data`;
	}

	API_GetAllRequestDataV2(userId) {
		return `/api/v2/user/${userId}/_all_of_user/request-data`;
	}

	API_DeleteAllProcessInfo() {
		return `/api/_save/process-infos`;
	}

	API_UploadFile() {
		return `/api/file/upload`;
	}

	// API_UploadFile365() {
	// 	return `/api/file/upload`;
	// }
	API_SaveAttachmentFile(id) {
		return `/api/attachment-files/${id}`;
	}

	API_GetAllAttachmentFileByTemplateFormId(templateFormId) {
		return `/api/template-form/${templateFormId}/_all/attachment-files`;
	}

	API_GetAllAttachmentFileByTemplateFormIdAndNotRequest(templateFormId) {
		return `/api/template-form/${templateFormId}/_all/attachment-files-not-request`;
	}

	API_GetAllAttachmentFileByManageStampInfoId(manageStampInfoId) {
		return `/api/manage-stamp-info/${manageStampInfoId}/_all/attachment-files`;
	}

	API_GetAllStepInProcessByProcessInfoId(processInfoId) {
		return `/api/process-infos/${processInfoId}/_all/step-in-processes`;
	}

	API_DownloadFile(fileId, fileName, fileExtension) {
		return `/api/file/download/${fileId}/${fileName}.${fileExtension}`;
	}

	API_DownloadFile_TheHien(fileId, fileName, fileExtension, userId) {
		return `/api/file/downloadFileTheHien/${fileId}/${fileName}.${fileExtension}?userId=${userId}`;
	}
	API_DownloadFileXML(fileId, fileName, fileExtension, xml) {
		return `/api/file/download/${fileId}/${fileName}.${fileExtension}?xml=${xml}`;
	}
	API_PreviewFile(fileId) {
		return `/api/file/preview/${fileId}`;
	}

	API_CreateFileTheHienV2() {
		return `/api/file/createFileTheHienV2`;
	}

	API_CreateFileTheHienV2ByList() {
		return `/api/file/createFileTheHienV2/list`;
	}

	API_DownloadFileTheHienV2(id) {
		return `/api/file/downloadFileTheHienV2/${id}`;
	}

	FullAPI_DownloadFile(fileId, fileName, fileExtension, contentType) {
		let apiUrl = store.state.config.apiUrl;
		return `${apiUrl}/api/file/download/${fileId}/${fileName}.${fileExtension}?type=${contentType}`;
	}

	API_DownloadFileById(fileId, contentType) {
		return `/api/file/download/${fileId}?type=${contentType}`;
	}

	FullAPI_DownloadFileById(fileId, contentType) {
		let apiUrl = store.state.config.apiUrl;
		return `${apiUrl}/api/file/v1/download/${fileId}?type=${contentType}`;
	}

	API_GetFolderContent(id) {
		return `/api/folder/${id}`;
	}

	API_CreateRequestDataLoop() {
		return `/api/request-data-loop/create`;
	}
	API_UpdateRequestDataLoop(id) {
		return `/api/request-data-loop/update/${id}`;
	}
	API_DeleteRequestDataLoop() {
		return `/api/request-data-loop/_all/delete`;
	}
	API_GetAllRequestDataLoop() {
		return `/api/_all/request-data-loop`;
	}

	// API_CreateFolder() {
	// 	return `/api/folder/`;
	// }
	// API_RenameFolder(id, folderName) {
	// 	return `/api/folder/${id}?folderName=${folderName}`;
	// }
	API_DeleteFolder(id) {
		return `/api/file/${id}`;
	}

	API_GetAllRank() {
		return `/api/_all/ranks`;
	}

	API_GetAllSteps() {
		return `/api/_all/steps`;
	}

	API_CreateStep() {
		return `/api/steps/`;
	}

	API_UpdateStep(id) {
		return `/api/steps/${id}`;
	}

	API_DeleteAllStep() {
		return `/api/_save/steps`;
	}

	API_GetAllRankByOrganizationId(id) {
		return `/api/organization/_all/${id}/rank`;
	}

	API_GetAllUserInfo() {
		return `/api/_all/user-infos`;
	}

	API_SaveAllUserInfo() {
		return `/api/_save/user-infos`;
	}

	API_DeleteUsersBulkCategoryGroup() {
		return `/api/category-groups/delete-users-bulk`;
	}

	API_GetAllByProcessInfoId(id) {
		return `/api/process-infos/${id}/_all/step-in-processes`;
	}

	API_GetAllByStepInProcessId(id) {
		return `/api/step-in-processes/${id}/_all/user-in-steps`;
	}

	API_DeleteStepInProcess(id) {
		return `/api/step-in-processes/${id}`;
	}

	API_UpdateStepInProcess(id) {
		return `/api/step-in-processes/${id}`;
	}

	API_CreateUserInStep() {
		return `/api/user-in-steps`;
	}

	API_DeleteUserInStep(id) {
		return `/api/user-in-steps/${id}`;
	}

	// API_UpdateUserInStep(id) {
	// 	return `/api/user-in-steps/${id}`;
	// }
	API_CreateStepInProcess() {
		return `/api/step-in-processes`;
	}

	API_CreateUserShareStepInProcess() {
		return `/api/user-share-in-steps`;
	}

	API_DeleteUserShareStepInStep(id) {
		return `/api/user-share-in-steps/${id}`;
	}

	API_DeleteRequestData(id) {
		return `/api/request-data/${id}`;
	}
	API_CheckFileManualSign(id) {
		return `/api/sign/checkFileManualSign/${id}`;
	}

	API_DeleteAllRequestData() {
		return `/api/_delete/request-data`;
	}
	API_SignGenerateTextImageByUser() {
		return `/api/sign/generateTextImageByUser`;
	}

	// API_GetAttachmentFile(id) {
	// 	return `/api/template-form/${id}/_all/attachment-files`;
	// }
	// API_CopyFile() {
	// 	return `/api/file/copy-file`;
	// }
	API_CreateAttachmentFile() {
		return `/api/attachment-files`;
	}

	API_UpdateAttachmentFile(id) {
		return `/api/attachment-files/${id}`;
	}

	API_GetAllAttachmentFileByRequestDataId(id) {
		return `/api/request-data/${id}/_all/attachment-files`;
	}

	API_UpdateRequestData(id) {
		return `/api/request-data/${id}`;
	}

	API_GetAllByUserIdRequestData(id) {
		return `/api/v2/user/${id}/_all/request-data`;
	}

	// API_GetAllRequestNeedHandlerByUserId(id) {
	// 	return `/api/v2/user/${id}/_all_need_handle/request-data`;
	// }
	// API_GetAllByUserIdRequestDataV2(id) {
	// 	return `/api/v1/user/${id}/_all/request-data`;
	// }
	API_GetAllUserInfos() {
		return `/api/_all/user-infos`;
	}

	API_DeleteAllFilesById(id) {
		return `/api/template-form/${id}/_all/attachment-files`;
	}

	// API_CheckCodeProcessInfo() {
	// 	return `/api/check_code/process-infos`;
	// }
	// API_GetAllRequestDataNeedHandle(id) {
	// 	return `/api/user/${id}/_all_need_handle/request-data`;
	// }
	API_UpdateFile(id, fileName = false) {
		return (
			`/api/file/update-file/${id}` +
			(!fileName ? "" : `?fileName=${fileName}`)
		);
	}

	API_UpdateFileTheHienBase64(id) {
		return `/api/file/update-file-the-hien-base64/${id}`;
	}

	API_SignFileCoAnhChuKyBase64() {
		return `/api/sign/sign-file-co-anh-chu-ky-base64`;
	}

	API_UpdateStepData(id) {
		return `/api/step-data/${id}`;
	}

	API_DeleteStepData(id) {
		return `/api/step-data/${id}`;
	}

	// API_GetRequestAboutToExpireByUserId(id) {
	// 	return `/api/user/${id}/_all_about_to_expire/request-data`;
	// }
	// API_GetRequestOverDueByUserId(id) {
	// 	return `/api/user/${id}/_all_overdue/request-data`;
	// }
	API_GetCountAboutToExpireByUserId(id) {
		return `/api/user/${id}/_count_about_to_expire/request-data`;
	}

	API_GetCountOverDueByUserId(id) {
		return `/api/user/${id}/_count_overdue/request-data`;
	}

	// API_GetCountInProcessingByUserId(id) {
	// 	return `/api/user/${id}/_count_in_processing_time/request-data`;
	// }
	API_GetCountRequestNeedHandle(id) {
		return `/api/v2/user/${id}/_count_all_need_handle/request-data`;
	}

	API_GetAllRole() {
		return `/api/_all/roles`;
	}

	// API_GetRequestDataSharedByUserId(id) {
	// 	return `/api/user/${id}/_all_shared_to_user/request-data`;
	// }
	// API_GetRequestInProcessing(id) {
	// 	return `/api/user/${id}/_all_in_processing_time/request-data`;
	// }
	// API_ApproveRequest() {
	// 	return `/api/approve/request-data`;
	// }
	API_CopyPYC() {
		return `/api/copy/request-data`;
	}
	API_CopyFromPreviousPYC(id) {
		return `/api/copy/request-data/${id}`;
	}
	API_GetRequestDrafting(id) {
		return `/api/v2/user/${id}/_all_drafting/request-data`;
	}

	API_GetRequestFollowing(id) {
		return `/api/v2/user/${id}/_all_following/request-data`;
	}

	API_GetRequestApproved(id) {
		return `/api/v2/user/${id}/_all_approved/request-data`;
	}

	API_GetRequestSharedToUser(id) {
		return `/api/v2/user/${id}/_all_share_to_user/request-data`;
	}

	API_GetRequestGiveBack(id) {
		return `/api/v2/user/${id}/_all_give_back/request-data`;
	}

	API_GetRequestWaitApproval(id) {
		return `/api/v2/user/${id}/_all_wait_approval/request-data`;
	}
	API_GetRequestDataSearchMenu() {
		return `/api/v2/user/search_menu/paging/request-data`;
	}

	API_GetCountRequestDrafting(id) {
		return `/api/user/${id}/_count_drafting/request-data`;
	}

	API_GetAllRequestTypeByRequestGroupId(id) {
		return `/api/request_group/${id}/_all/request-types`;
	}

	API_GetRequestNeedProcess(id) {
		return `/api/v2/user/${id}/_all_need_handle/request-data`;
	}

	// API_GetRequestDataFollowing(id) {
	// 	return `/api/user/${id}/_all_following/request-data`;
	// }
	API_GetAllUserGroup() {
		return `/api/_all/user-groups`;
	}

	//lấy ra list chức năng
	API_GetAllFeature() {
		return `/api/_all/features`;
	}

	API_GetAllSignatureInformation(userId) {
		return `/api/user/${userId}/_all/signature-infomations`;
	}

	API_CreateSignatureInformation() {
		return `/api/signature-infomations`;
	}

	API_SaveSignatureInformation(id) {
		return `/api/signature-infomations/${id}`;
	}

	API_GetTemplateForm(id) {
		return `/api/template-forms/${id}`;
	}

	API_GetTemplateFormByIdWorkflow(id) {
		return `/api/workflow/template-forms/${id}`;
	}

	API_UploadTemplateFileCloud(id) {
		return `/api/file/upload?templateFormId=${id}`;
	}

	API_UploadManageStampCloud(requestDataId, userId) {
		return `/api/file/upload?requestDataId=${requestDataId}&userId=${userId}`;
	}

	API_UploadMailTemplateCloud(userId) {
		return `/api/file/upload?userId=${userId}`;
	}

	API_DeleteTemplateForm(id) {
		return `/api/template-forms/${id}`;
	}

	API_GetAllMailTemplate() {
		return `/api/_all/mail-templates`;
	}

	API_GetAllTemplateMailSms() {
		return `/api/_all/mail-sms-template-group`;
	}

	API_GetMailTemplate(id) {
		return `/api/mail-templates/${id}`;
	}

	API_CreateMailTemplate() {
		return `/api/mail-templates`;
	}

	API_SaveMailTemplate(id) {
		return `/api/mail-templates/${id}`;
	}

	API_GetBook() {
		return `/api/_all/dispatch-books`;
	}

	API_CreateUserGroup() {
		return `/api/user-groups`;
	}

	API_SaveUserGroup(id) {
		return `/api/user-groups/${id}`;
	}

	API_GetUserGroup(id) {
		return `/api/user-groups/${id}`;
	}

	API_CreateDispatchBook() {
		return `/api/dispatch-books`;
	}

	API_GetAllDispatchBook() {
		return `/api/dispatch-books`;
	}

	API_UpdateDispatchBook(id) {
		return `/api/dispatch-books/${id}`;
	}

	API_DeleteAllDispatchBook() {
		return `/api/_save/dispatch-books`;
	}

	API_GetAllStatus() {
		return `/api/_all/status`;
	}

	API_CreateStatus() {
		return `/api/status`;
	}

	API_UpdateStatus(id) {
		return `/api/status/${id}`;
	}

	API_GetStepDataByIdProcessData(id) {
		return `/api/process-data/${id}/_all/step-data`;
	}

	API_GetAttachmentFile(id) {
		return `/api/attachment-files/${id}`;
	}

	API_DeleteAttachmentFile(id) {
		return `/api/attachment-files/${id}`;
	}

	// Xóa tài liệu chính: xóa mềm theo cụm (bản gốc + bản đã ký + file thể hiện + toạ độ ký)
	API_DeleteMainDocument(id) {
		return `/api/attachment-files/main-document/${id}`;
	}

	API_CreateReqdataProcessHis() {
		return `/api/reqdata-process-his`;
	}

	API_GetReqdataProcessHisByID(id) {
		return `/api/request-data/${id}/_all/reqdata-process-his`;
	}

	API_GetCurrentUserInfo() {
		return "/api/current-user-info";
	}

	API_GetUserInfo(id) {
		return `/api/user-infos/${id}`;
	}

	API_CreateUserInfo() {
		return `/api/user-infos/`;
	}

	API_UpdateUserInfo(id) {
		return `/api/user-infos/${id}`;
	}

	API_ImportUserInfo() {
		return `/api/user-infos/import`;
	}

	API_StartUserInfoImport() {
		return `/api/user-infos/import-jobs`;
	}

	API_GetUserInfoImportStatus(jobId) {
		return `/api/user-infos/import-jobs/${jobId}`;
	}

	API_ExportUserInfoImportTemplate() {
		return `/api/user-infos/import-template`;
	}

	API_GetAllUserByRequest(id) {
		return `/api/v1/user/${id}/_all/request-data`;
	}

	API_Approve() {
		return `/api/process/request-data`;
	}

	API_Examine() {
		return `/api/examines`;
	}

	API_ExamineReply() {
		return `/api/examine-replies`;
	}

	API_GetAllStamp() {
		return `/api/_all/stamps`;
	}

	// API_GetAllRequestApprovedById(id) {
	// 	return `/api/v2/user/${id}/_all_approved/request-data`;
	// }
	API_GetRootFolder() {
		return `/api/folder/root/folder`;
	}

	API_Get365FolderContent(id) {
		return `/api/folder/${id}`;
	}

	API_Create365Folder() {
		return `/api/folder`;
	}

	API_Save365Folder(id, name) {
		return `/api/folder/rename/${id}?folderName=${name}`;
	}

	API_Delete365Folder(id) {
		return `/api/folder/${id}`;
	}

	API_Delete365File(id) {
		return `/api/file/${id}`;
	}

	API_GetAllSignDataByRequestData(id) {
		return `/api/request-data/${id}/_all/sign-data`;
	}

	API_ShowAllRequestDataCodeFromCongTacPhi(keyword, page, size) {
		if (!keyword || keyword === "undefined" || keyword === "null")
			keyword = "";
		if (keyword) keyword = encodeURIComponent(keyword);
		return `/api/_all/showAllRequestDataCodeFromCongTacPhi?keyword=${keyword}&page=${page}&size=${size}`;
		// return `/api/_all/showAllRequestDataCodeFromCongTacPhi?page=${page}&size=${size}`;
	}

	API_updateSignData(id) {
		return `/api/sign-data/${id}`;
	}

	API_GetAllManageStampInfoByRequestData(id) {
		return `/api/request-data/${id}/_all/manage-stamp-infos`;
	}

	API_updateManageStampInfo(id) {
		return `/api/manage-stamp-infos/${id}`;
	}

	API_createManageStampInfo() {
		return `/api/manage-stamp-infos`;
	}

	API_createSignData() {
		return `/api/sign-data`;
	}

	API_SaveAllUserGroup() {
		return `/api/_save/user-groups`;
	}

	API_GetAllSignature() {
		return `/api/_all/signature-infomations`;
	}

	API_CreateConsult() {
		return `/api/consults`;
	}

	API_CreateConsultReply() {
		return `/api/consult-replies`;
	}

	API_GetAllByUserAndRequestData(idUser, id) {
		return `/api/user/${idUser}/request-data/${id}/_all/examines`;
	}

	API_GetAllConsultByUserAndRequestData(idUser, id) {
		return `/api/user/${idUser}/request-data/${id}/_all/consults`;
	}

	API_CheckCoKySo() {
		return `/api/request-data/check-co-can-ky-so`;
	}

	// API_InformationInExchanges() {
	// 	return `/api/information-in-exchanges`;
	// }
	// API_CreateStepProcessDoc() {
	// 	return `/api/step-process-docs`;
	// }
	API_SendMail() {
		return `/api/mail/send-mail`;
	}

	API_Sign() {
		return `/api/sign/`;
	}

	API_SignAnonymous() {
		return `/api/sign/anonymous`;
	}

	// API_UpdateReqdataProcessHis(id) {
	// 	return `/api/reqdata-process-his/${id}`;
	// }
	// API_GetReqdataProcessHisById(id) {
	// 	return `/api/reqdata-process-his/${id}`;
	// }
	API_DownloadFile365(param, fileName, extension) {
		let url = `/api/file/download/${fileName}.${extension}`;
		let start = true;
		for (let key in param) {
			if (start) {
				start = false;
				url += "?" + key + "=" + param[key];
			} else {
				url += "&" + key + "=" + param[key];
			}
		}
		return url;
	}

	API_GetAllAttachmentFileByMailTemplateId(id) {
		return `/api/mail-template/${id}/_all/attachment-files`;
	}

	// API_GetAllChildOrg(id) {
	// 	return `/api/_all-child-org/${id}/organizations`;
	// }
	// API_GetCountAllRequestV2(id) {
	// 	return `/api/v2/user/${id}/_count/request-data`;
	// }
	// API_GetAllOtpByRequestDataId(requestDataId) {
	// 	return `/api/request-data/${requestDataId}/_all/otps`;
	// }
	// API_GetAllRqdataProcessHistory(id) {
	// 	return `/api/request-data/${id}/_all/reqdata-process-his`;
	// }
	// API_PostRqdataProcessHistory() {
	// 	return `/api/reqdata-process-his`;
	// }
	API_GetByCurrentSteps(id, ignoreField = true) {
		return `/api/current-steps/${id}/_all/step-data?ignoreField=${ignoreField}`;
	}

	API_CreateRequestRecall() {
		return `/api/request-recalls`;
	}

	API_GetAllRequestRecallByRequestData(id) {
		return `/api/request-data/${id}/_all/request-recalls`;
	}

	API_UpdateRequestRecall(id) {
		return `/api/request-recalls/${id}`;
	}

	API_GetStatistic() {
		return `/api/statistic/dashboard`;
	}

	API_GetChildOrg(id) {
		return `/api/_child-org/${id}/organizations`;
	}

	API_GetStatisticByDay() {
		return `/api/statistic-day/dashboard`;
	}

	API_GetStatisticByStatus() {
		return `/api/statistic-status/dashboard`;
	}

	API_CreateRole() {
		return `/api/roles`;
	}

	API_UpdateRole(id) {
		return `/api/roles/${id}`;
	}

	API_SaveUpdateRole() {
		return `/api/_save/role`;
	}

	// API_GenerateOTP(id) {
	// 	return `/api/_generate/${id}/otps`;
	// }
	API_DeleteRole() {
		return `/api/_save/roles`;
	}

	API_ResetPasswordUser() {
		return `/api/update-data/user-infos`;
	}

	API_ChangePassword() {
		return `/api/change-password`;
	}

	API_UpdateCurrentUserInfo() {
		return `/api/current-user-info`;
	}

	API_SignAll() {
		return `/api/sign/kySoHangLoat`;
	}
	API_RejectAll() {
		return `/api/request-data-to-reject-all`;
	}

	API_GetAllProcessIgnoreField(check) {
		return `/api/_all/process-infos?ignoreField=${check}`;
	}

	API_GetAllRequestIgnoreField(check) {
		return `/api/_all/requests?ignoreField=${check}`;
	}

	API_GetAllProcessInfosCustom() {
		return `/api/all/process-infos/custom`;
	}

	API_CheckExistRequestByRequestType(requestTypeId) {
		return `/api/check_exist_request/${requestTypeId}/request-types`;
	}

	API_AddPrimaryFile(userId, requestDataId, templateFormId = null) {
		if (templateFormId) {
			return `/api/_add_primary_file/${userId}/request-data?requestDataId=${requestDataId}&templateFormId=${templateFormId}`;
		} else {
			return `/api/_add_primary_file/${userId}/request-data?requestDataId=${requestDataId}`;
		}
	}

	API_GetTemplateByRequestId(id) {
		return `/api/_all/request/${id}/template-forms`;
	}

	API_GetFormByRequestId(id) {
		return `/api/_all_by_request/${id}/forms`;
	}

	API_GetAllCargo() {
		return `/api/_all/centralized-shoppings`;
	}

	// API_GetAllBusinessPartner() {
	// 	return `/api/_all/business-partners`;
	// }
	// API_GetCheckOtp(requestDataId, opt) {
	// 	return `/api/_check/otps?requestDataId=${requestDataId}&opt=${opt}`;
	// }
	API_DashboardLead() {
		return `/api/_leader_statistic/member/dashboard`;
	}

	API_GetOrganizationDashboard(id) {
		return `/api/_child-org/${id}/organizations`;
	}

	API_GetAllNeedHandleRequestData(id, status) {
		return `/api/v3/user/${id}/_all_need_handle/request-data/${status}`;
	}

	API_GetRequestByRqGroupId(id) {
		return `/api/_all/request_group/${id}/requests?ignoreField=true`;
	}

	API_GetRequestsFromParentRequest(id) {
		return `/api/_all/request/${id}/requests-children`;
	}

	API_GetRequestByRequestGroupIdV3(id, organizationId) {
		return `/api/workflow/_all/request_group/${id}/requestsV2?ignoreField=true&organizationId=${organizationId}`;
	}

	API_GetRequestByRequestGroupIdV2(id) {
		return `/api/workflow/_all/request_group/${id}/requests?ignoreField=true`;
	}

	GetAllProcessInfosByRequestId_v2(requestId) {
		return `/api/workflow/_all/${requestId}`;
	}

	GetAllUser(page, size) {
		return `/api/user-infos?page=${page}&size=${size}`;
	}

	SearchAllUser(page = 0, size = 10) {
		return `/api/search_custom/user-infos?page=${page}&size=${size}`;
	}

	GetAllUserGroup(page, size) {
		return `/api/user-groups?page=${page}&size=${size}`;
	}

	GetAllRole(page, size) {
		return `/api/roles?page=${page}&size=${size}`;
	}

	GetAllRank(page, size) {
		return `/api/ranks?page=${page}&size=${size}`;
	}

	GetAllOrganization(page, size) {
		return `/api/search_custom/organizations?page=${page}&size=${size}`;
	}

	GetAllTemplateForm(page, size) {
		return `/api/template-forms?page=${page}&size=${size}`;
	}

	GetAllCategory(page, size) {
		return `/api/category-groups?page=${page}&size=${size}`;
	}

	GetAllProcessInfo(page, size) {
		return `/api/process-infos?page=${page}&size=${size}`;
	}

	GetAllStep(page, size) {
		return `/api/steps?page=${page}&size=${size}`;
	}

	// Dashboard TCT
	LayDuLieuTheoRequestId(id) {
		return `/api/dashboard/layDuLieuTheoRequestId?type=${id}`;
	}

	LayDuLieuBieuDoThongKeSoLuongQuyTrinh() {
		return `/api/dashboard/layDuLieuBieuDoThongKeSoLuongQuyTrinh`;
	}

	LayDuLieuBieuDoThongKeSoLuongQuyTrinhTheoDonViTao(fromDate, toDate) {
		return `/api/dashboard/layDuLieuBieuDoThongKeSoLuongQuyTrinhTheoDonViTao?fromDate=${fromDate}&toDate=${toDate}`;
	}

	LayDuLieuThongKePhieuYeuCauTheoQuyTrinh(fromDate, toDate, id) {
		return `/api/dashboard/layDuLieuThongKePhieuYeuCauTheoQuyTrinh?fromDate=${fromDate}&toDate=${toDate}&type=${id}`;
	}

	LayDuLieuThongKePhieuYeuCauTheoLoaiYeuCau(fromDate, toDate) {
		return `/api/dashboard/layDuLieuThongKePhieuYeuCauTheoLoaiYeuCau?fromDate=${fromDate}&toDate=${toDate}`;
	}

	GetAllRequestGroup(page, size) {
		return `/api/request-groups?page=${page}&size=${size}`;
	}

	GetAllRequestType(page, size) {
		return `/api/request-types?page=${page}&size=${size}`;
	}

	GetAllRequest(page, size) {
		return `/api/requests?page=${page}&size=${size}`;
	}

	GetAllOTP(page, size) {
		return `/api/otps?page=${page}&size=${size}`;
	}

	GetAllMailTemplate(page, size) {
		return `/api/mail-templates?page=${page}&size=${size}`;
	}

	GetAllDispatchBook(page, size) {
		return `/api/dispatch-books?page=${page}&size=${size}`;
	}

	// GetAllCentralizeShopping(page, size) {
	// 	return `/api/centralized-shoppings?page=${page}&size=${size}`;
	// }
	// GetAllBusinessPartner(page, size) {
	// 	return `/api/business-partners?page=${page}&size=${size}`;
	// }
	GetUserByFilter(page, page_size) {
		return `/api/search_user/user-infos?page=${page}&size=${page_size}`;
	}

	GetUserByFiltersCustom(page, page_size) {
		return `/api/search_custom/user-infos?page=${page}&size=${page_size}`;
	}

	API_SyncUsers(userId) {
		return `/api/sync-user/${userId}`;
	}

	API_CountRequestDataOfUser(userId) {
		return `/api/v2/user/${userId}/_count_all_of_user/request-data`;
	}

	API_CountRequestDataDrafting(userId) {
		return `/api/v2/user/${userId}/_count_all_drafting/request-data`;
	}

	API_CountRequestDataGiveBack(userId) {
		return `/api/v2/user/${userId}/_count_all_give_back/request-data`;
	}

	API_CountRequestDataFollow(userId) {
		return `/api/v2/user/${userId}/_count_all_following/request-data`;
	}

	API_CountRequestDataShareToUser(userId) {
		return `/api/v2/user/${userId}/_count_all_share_to_user/request-data`;
	}

	API_CountRequestDataWaitApproval(userId) {
		return `/api/v2/user/${userId}/_count_all_wait_approval/request-data`;
	}

	API_CountRequestDataApproval(userId) {
		return `/api/v2/user/${userId}/_count_all_approved/request-data`;
	}

	API_GetAllAttachmentFileByRequestDataIdHasSign(requestDataId) {
		return `/api/sign/_all/${requestDataId}/file_sign`;
	}

	API_GetAllByRequestDataIdToGetIsRequiredSignature() {
		return `/api/request-data-to-get-is-required-signature`;
	}

	API_GetAllTemplateFormV2() {
		return `/api/_all/has_file/template-forms?ignoreFile=true`;
	}

	API_SAPSyncContract() {
		return `/api/sync_sap/contract`;
	}

	API_GetAllFormDriverFolder(id, itemid) {
		if (!itemid) {
			return `/api/data-room/v2/_all/item_of_drive?driveId=${id}`;
		} else {
			return `/api/data-room/v2/_all/item_of_drive?driveId=${id}&itemId=${itemid}`;
		}
	}

	API_GetRequestByStatus(id) {
		return `/api/_status/${id}/request-data`;
	}

	API_UpdateRequestDataContractNumber(id) {
		return `/api/_update_contract/${id}/request-data`;
	}

	API_ApproveAll() {
		return `/api/process_concurrent/request-data`;
	}

	API_GetAllFieldDataByRequestDataId(id, page, size = 20) {
		return `/api/request-data/${id}/_all/field-data?page=${page}&size=${size}&ignoreField=true`;
	}

	API_UpdateAllFieldDataByRequestDataId(id) {
		return `/api/field-data/${id}`;
	}

	API_UpdateAllFieldDataByRequestDataId_SaveAll(
		requestDataId,
		useTemplate = false,
	) {
		return `/api/_save_custom/field-data/${requestDataId}?useTemplate=${useTemplate}`;
	}

	API_UpdateAllFieldDataByRequestDataId_SaveAll_NoFill(requestDataId) {
		return `/api/_save_custom/field-data/${requestDataId}?fillIn=false`;
	}

	API_UpdateFieldDataAfterApproval(stepDataId) {
		return `/api/field-data/after-approval/save/${stepDataId}`;
	}

	API_GetHisTradeRequestData(id) {
		return `/api/request-data/${id}/_all/information-in-exchanges`;
	}

	API_Chat() {
		return `/api/information-in-exchanges`;
	}

	API_CreateAllFieldDataByRequestDataId() {
		return `/api/_create_custom/field-data`;
	}
	API_CreateAllFieldDataByRequestDataIdV2(autoCreate) {
		return `/api/_create_custom/field-data-v2?autoCreate=${autoCreate}`;
	}
	// API_GetAllRequestNeedProcessPaging(userId) {
	// 	return `/api/v2/user/${userId}/_all_need_handle/paging/request-data?page=0&size=10`;
	// }
	API_GetRequestDraftingPaging(userId, pageSize = 10) {
		return `/api/v2/user/${userId}/_all_drafting/paging/request-data?page=0&size=${pageSize}`;
	}

	API_GetRequestApprovedPaging(userId, pageSize = 10) {
		return `/api/v2/user/${userId}/_all_approved/paging/request-data?page=0&size=${pageSize}`;
	}

	API_GetRequestWaitApprovalPaging(userId, pageSize = 10) {
		return `/api/v2/user/${userId}/_all_wait_approval/paging/request-data?page=0&size=${pageSize}`;
	}

	API_GetRequestGiveBackPaging(userId, pageSize = 10) {
		return `/api/v2/user/${userId}/_all_give_back/paging/request-data?page=0&size=${pageSize}`;
	}

	API_GetRequestFollowPaging(userId, pageSize = 10) {
		return `/api/v2/user/${userId}/_all_following/paging/request-data?page=0&size=${pageSize}`;
	}

	API_GetRequestSharedToUserPaging(userId, pageSize = 10) {
		return `/api/v2/user/${userId}/_all_share_to_user/paging/request-data?page=0&size=${pageSize}`;
	}

	API_GetRequestOfUserPaging(userId, pageSize = 10) {
		return `/api/v2/user/${userId}/_all_of_user/paging/request-data?page=0&size=${pageSize}`;
	}

	API_GetAllRequestNeedHandlePaging(userId, pageSize = 10) {
		return `/api/v2/user/${userId}/_all_need_handle/paging/request-data?page=0&size=${pageSize}`;
	}

	API_GetAllProcessInfoCustom(page = 0, pageSize = 10) {
		return `/api/search_custom/process-infos?page=${page}&size=${pageSize}`;
	}

	API_GetRequestCustom(page = 0, pageSize = 10) {
		return `/api/search_custom/requests?page=${page}&size=${pageSize}`;
	}

	API_GetAllTemplateCustom(page = 0, pageSize = 10) {
		return `/api/search_custom/template-forms?page=${page}&size=${pageSize}`;
	}

	// API_GetAllCentralizedShoppings() {
	// 	return `/api/_all/centralized-shoppings`;
	// }
	API_SearchCustomCentralizedShoppings(page = 0, pageSize = 10) {
		return `/api/search_custom/centralized-shoppings?page=${page}&size=${pageSize}`;
	}

	API_SearchCentralizedShoppingsPaging(page = 0, pageSize = 10) {
		return `/api/centralized-shoppings?page=${page}&size=${pageSize}`;
	}

	API_GetCodeAttachName() {
		return `/api/_all/generate-attach-name-option`;
	}

	API_GetCodeAttachNameV2(requestId) {
		return `/api/v2/requests/${requestId}/_all/generate-code-option`;
	}

	API_GetAllRankWorkflow() {
		return `/api/workflow/_all/ranks`;
	}

	SearchAllUserWorkflow(page = 0, size = 10) {
		return `/api/workflow/_all/user-infos?page=${page}&size=${size}`;
	}
	GetUserInfosByRoleWorkflow(page = 0, size = 10) {
		return `/api/workflow/_all/user-infos-by-role?page=${page}&size=${size}`;
	}

	GetUsersByStepData(
		stepDataId,
		keyword,
		page = 0,
		size = 10,
		organizationParentId,
	) {
		return `/api/workflow/_all/users-according-step-data/${stepDataId}?keyword=${keyword}&page=${page}&size=${size}&organizationParentId=${organizationParentId}`;
	}

	GetUsersCTP(
		stepDataId,
		keyword,
		page = 0,
		size = 10,
		organizationParentId,
	) {
		return `/api/workflow/_all/users-ctp/${stepDataId}?keyword=${keyword}&page=${page}&size=${size}&organizationParentId=${organizationParentId}`;
	}

	GetReportToTrinhCongTac(fromDate, toDate, fieldDataCode) {
		return `/api/workflow/report-to-trinh-cong-tac?fromDate=${fromDate}&toDate=${toDate}&fieldDataCode=${fieldDataCode}`;
	}

	API_GetReportGeneralByFilter() {
		return `/api/v2/user/getAllRequestDataByProcessTime/request-data`;
	}
	API_ReportCustomCreateOrUpdate() {
		return `/api/reportCustom/createOrUpdate`;
	}
	API_SearchReportCustom() {
		return `/api/reportCustom/searchReportCustom`;
	}
	API_ReportCustomDeleteAll() {
		return `/api/reportCustom/deleteAll`;
	}
	API_ReportCustomGetDataReport(
		id,
		fromDate,
		toDate,
		timeDoneStart,
		timeDoneEnd,
	) {
		let url = `/api/reportCustom/getDataReport?fromDate=${fromDate}&toDate=${toDate}&id=${id}`;
		if (timeDoneStart) {
			url += `&timeDoneStart=${timeDoneStart}`;
		}
		if (timeDoneEnd) {
			url += `&timeDoneEnd=${timeDoneEnd}`;
		}
		return url;
	}
	API_GetReportGeneralByFilter2() {
		return `/api/request-data/statistical/process-status`;
	}
	API_GetReportSystemOverview() {
		return `/api/reportSystem/reportSystemOverview`;
	}
	API_GetReportSystemReportUsed() {
		return `/api/reportSystem/reportUsed`;
	}
	API_GetReportSystemReportRequestTypeCompletedOnTime() {
		return `/api/reportSystem/reportRequestTypeCompletedOnTime`;
	}
	API_GetReportGeneralByFilter3() {
		return `/api/request-data/statistical/process-status/view`;
	}

	API_GetAllOrganizationsParent() {
		return `/api/workflow/_all/organizations/parent`;
	}

	// API_GetAllECMConfigFolderOfRequestGroupAndOrganization(
	// 	requestGroupId,
	// 	organizationId,
	// ) {
	// 	return `/api/ecm/findAllFolderOfRequestGroupAndOrganization?requestGroupId=${requestGroupId}&organizationId=${organizationId}`;
	// }

	API_ExportExcel(requestDataId) {
		return `/api/request-data/export-excel/${requestDataId}`;
	}

	API_GetAllRequestGroupsByRole() {
		return "/api/_all/request-groups-by-role";
	}

	API_GetAllRequestTypesByRole() {
		return "/api/_all/request-types-by-role";
	}

	API_GetRollbackStepDataEndpoint(id) {
		return `/api/his/rollBack/${id}`;
	}

	API_OverwriteStepData() {
		return `/api/step-data/createOrUpdate`;
	}

	API_GetHashFile(id) {
		return `/api/file/hash-file/${id}`;
	}

	API_TokenV2CreateEmptySignatureToken() {
		return `/api/sign/token_v2/create_empty_signature_token`;
	}

	API_TokenV2MergeSignatureToken() {
		return `/api/sign/token_v2/merge_signature_token`;
	}
	API_CheckAttachmentFiles(id) {
		return `/api/request-data/${id}/_all/check-attachment-files`;
	}

	API_ReviewAttachmentFiles(stepDataId) {
		return `api/attachment-files/update-lock/${stepDataId}`;
	}

	API_CheckUserCanViewRequestData(id) {
		return `/api/can-view-request-data/${id}`;
	}
	API_DownloadMultiFile() {
		return `/api/file/download/multiFile`;
	}

	// Opinion document APIs
	API_OpinionCreateAndSign() {
		return `/api/opinion/create-and-sign`;
	}

	API_OpinionUploadFile() {
		return `/api/opinion/upload-file`;
	}

	API_GetOpinionList(requestDataId) {
		return `/api/opinion/list/${requestDataId}`;
	}

	API_OpinionSaveSignaturePosition() {
		return `/api/opinion/save-signature-position`;
	}

	API_OpinionSign() {
		return `/api/opinion/sign`;
	}
}

const administratorAPI = new AdministratorAPI();
export default administratorAPI;
